import { ReduceStore } from 'flux/utils';
import { Map, Record } from 'immutable';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';

export class Secret extends Record({
  id: null,
  resourceId: null,
  secretName: null,
  secretKey: null,
  secretValue: null,
  resource: null,
}) {
  get valid() {
    return +this.resourceId !== -1 && (
      !!this.secretValue || this.id !== -1
    );
  }
}

const rawSecretToRecord = rawSecret => (
  new Secret({
    id: +rawSecret.id,
    resourceId: rawSecret.resource_id,
    secretName: rawSecret.secret_name,
    secretKey: rawSecret.secret_key,
  })
);

const transformSecretList = rawSecrets => (
  new Map(rawSecrets.map(rawSecret => [rawSecret.id, rawSecretToRecord(rawSecret)]))
);

class SecretStore extends ReduceStore {
  getInitialState() {
    return new Map();
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.Credentials.NEW_SECRET_ADDED:
        return this.getState().set(-1, new Secret({ id: -1, resourceId: -1, resourceType: -1 }));
      case Constants.Credentials.NEW_SECRET_REMOVED:
        return this.getState().delete(-1);
      case Constants.Credentials.SECRETS_RECEIVED:
        return this.getState().merge(transformSecretList(action.secrets));
      case Constants.Credentials.SECRET_CREATED:
        return this.getState()
                 .set(action.secret.id, rawSecretToRecord(action.secret))
                 .delete(-1);
      case Constants.Credentials.SECRET_RECEIVED:
      case Constants.Credentials.SECRET_UPDATED:
        return this.getState().set(action.secret.id, rawSecretToRecord(action.secret));
      case Constants.Credentials.SECRET_DELETED:
        return this.getState().delete(action.secretId);
      default:
        return state;
    }
  }
}

const instance = new SecretStore(AppDispatcher);
export default instance;
